<template>
  <button :class="['header-icon-button', { 'header-icon-button--small': small }]" @click="onClick">
    <div class="icon-container" :class="{ 'alt-color': altColor, 'icon-container--small': small }">
      <icon :icon="icon" :white="altColor" :small="small" />
      <div v-if="showBasketCount" class="basket-count" v-html="basketCount" />
    </div>
    <span v-if="text" v-html="text" />
  </button>
</template>

<script lang="ts">
import Icon from './Icon.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'IconButton',
  components: {
    Icon
  },
  props: {
    icon: {
      type: String,
      default() {
        return '';
      }
    },
    text: {
      type: String,
      default() {
        return '';
      }
    },
    altColor: {
      type: Boolean,
      default() {
        return false;
      }
    },
    basketCount: {
      type: Number,
      default() {
        return 0;
      }
    },
    small: {
      type: Boolean,
      default() {
        return false;
      }
    },
    sendClickTrackingEvent: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  computed: {
    showBasketCount(): boolean {
      return !isNaN(this.basketCount) && this.basketCount > 0;
    }
  },
  methods: {
    sendTrackingEvent(): void {
      if (this.text)
        this.$store.dispatch('Events/register', {
          event: 'cvi-header-click',
          id: 'cviHeader',
          eventLabel: this.text
        });
    },
    onClick(): void {
      if (this.sendClickTrackingEvent) this.sendTrackingEvent();
      this.$emit('custom-click');
    }
  }
});
</script>

<style lang="scss" scoped>
@import 'src/styles/all.scss';
@import 'node_modules/foundation-sites/scss/util/util';
.header-icon-button {
  cursor: pointer;
  color: rgb(0, 0, 0);
  font-weight: 500;
  line-height: rem-calc(24px);
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  overflow: visible;
  border: 0;
  background: none;

  &--small,
  .icon-container--small {
    width: rem-calc(36px);
    height: rem-calc(36px);
    font-size: 14px;
  }

  .icon-container {
    border: 2px solid rgba(0, 0, 0, 0.15);
    border-radius: 50%;
    color: $primary-color;
    justify-content: center;
    display: inline-flex;
    flex-wrap: wrap;
    align-content: center;
    box-sizing: border-box;
    position: relative;

    &--small {
      width: rem-calc(36px);
      height: rem-calc(36px);
      font-size: 14px;
    }

    &:hover {
      background-color: rgba(58, 88, 109, 0.04);
    }

    &.alt-color {
      background-color: $primary-color;
      border-color: $primary-color;
      color: white;

      &:hover {
        background-color: $disturber-color;
        border-color: $disturber-color;
      }
    }

    .basket-count {
      position: absolute;
      top: -5px;
      right: -15px;
      width: rem-calc(25px);
      height: rem-calc(25px);
      border-radius: 50%;
      background-color: map-get($foundation-palette, 'alert');
      color: $white;
      font-family: $body-font-family;
      font-size: rem-calc(14px);
      line-height: rem-calc(22px);
    }
  }

  span {
    @include breakpoint(small only) {
      margin-top: 0;
    }

    @include breakpoint(medium up) {
      margin-top: rem-calc(4px);
    }

    white-space: nowrap;
  }
}

@include breakpoint(small only) {
  .icon-container {
    width: rem-calc(36px);
    height: rem-calc(36px);
    font-size: 14px;
  }
}

@include breakpoint(medium up) {
  .icon-container {
    &:not(&--small) {
      width: rem-calc(48px);
      height: rem-calc(48px);
      font-size: 16px;
    }
  }
}
</style>
